import { useState } from "react";
import { Globe } from "lucide-react";

/**
 * Clean language toggle. Uses Google Translate under the hood
 * but hides all Google UI. Switching back to English reloads 
 * the page (only reliable method with the GT widget).
 */
const TranslateWidget = () => {
  const [isSpanish, setIsSpanish] = useState(false);

  const toggle = () => {
    if (isSpanish) {
      // Switching back to English — clear cookies and reload
      document.cookie = "googtrans=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
      document.cookie = "googtrans=; path=/; domain=." + window.location.hostname + "; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
      window.location.reload();
    } else {
      // Switch to Spanish via the hidden combo
      const combo = document.querySelector(".goog-te-combo");
      if (combo) {
        combo.value = "es";
        combo.dispatchEvent(new Event("change"));
        setIsSpanish(true);
      }
    }
  };

  return (
    <button
      onClick={toggle}
      className="notranslate flex items-center gap-1.5 text-[#F0F4F3]/60 hover:text-[#C8E64E] text-xs font-medium transition-colors border border-[#F0F4F3]/20 rounded px-2.5 py-1"
      data-testid="lang-toggle"
    >
      <Globe size={12} />
      {isSpanish ? "English" : "Español"}
    </button>
  );
};

export default TranslateWidget;
